import HashLoader from "react-spinners/HashLoader";
import PropTypes from "prop-types";

export function Loading({ message = "" }) {
  const spinnerStyle = {
    display: "block",
    margin: "0 auto",
  };

  return (
    <div
      style={{
        minHeight: "80vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <HashLoader
        cssOverride={spinnerStyle}
        color="#39a935"
        loading={true}
        size={80}
      />
      <div style={{ marginTop: "2rem", textAlign: "center" }}>
        <p className="text-m">{message}</p>
      </div>
    </div>
  );
}

Loading.propTypes = {
  message: PropTypes.string,
};